<template>
  <div class="pt3 pb3">
    <div class="x xjb" v-if="lang === 'en'">
      <h1>Contact</h1>
    </div>
    <div class="x xjb" v-else>
      <h1>Kontakt</h1>
    </div>
    <div class="form-wrapper w100">
      <div class="c12 x xjb">
        <div class="c4 py0-5 pr1">
        </div>
        <div class="c8">
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">Europeam Media Art Festival</div>
            <div class="field c8">
              Lohstr. 45A<br />
              D-49074 Osnabrueck Germany<br />
              +49 (0)541 21658<br /><br />
              <a href="mailto:info@emaf.de">info@emaf.de</a><br />
              <a href="https://emaf.de" target="_blank" rel="noopener noreferrer">www.emaf.de</a><br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <a href="https://www.emaf.de/de/Impressum%20-%20Datenschutz.html"  target="_blank" rel="noopener noreferrer" class="button absolute x xjb xac" v-if="lang === 'en'">
      <div class="w100 tar">
        Impressum & Datenschutz →
      </div>
    </a>
    <a href="https://www.emaf.de/en/Imprint%20-%20Privacy%20Policy.html"  target="_blank" rel="noopener noreferrer" class="button absolute x xjb xac" v-else>
      <div class="w100 tar">
        Imprint & Privacy Policy →
      </div>
    </a>
  </div>

</template>

<script>
export default {
  name: 'Contact',
  computed: {
    lang () {
      return this.$store.state.language
    }
  }
}
</script>

<style scoped>
.label {
  font-feature-settings: 'tnum';
}

.field {
  font-size: 1rem;
}

.button {
  text-decoration: none;
}
</style>
